export default {
    namespaced: true,
    account_settings: {
      title: "configuración de cuenta",
      mobile_app: {
        title: "aplicación móvil",
        description: "Puedes vincular tu aplicación móvil con tu cuenta escaneando el código QR",
        timeout_with_minutes: "Válido por {minutes} minutos y {seconds} segundos",
        timeout_without_minutes: "Válido por {seconds} segundos",
      },
      appColors: {
        title: "Colores de la aplicación",
        description: "puedes cambiar el tema de la aplicación aquí",
        updating: "Actualizando colores",
        success: "Colores cambiados exitosamente, recargando página...",
        main_dashboard: "Panel Principal",
        components: "Componentes",
        images: "Imagenes",
        success_delete: "Tema borrado correctamente",
        confirm_delete: "¿Estás seguro de eliminar el tema '%theme%'?",
        success_edit: "Tema actualizado correctamente",
        success_create: "Tema creado correctamente",
        theme_builder_description: "seleccione o personalice el tema de su UI"
      }
    },
};
  